import { render, staticRenderFns } from "./CrmStatus.vue?vue&type=template&id=4e9ef602"
import script from "./CrmStatus.vue?vue&type=script&lang=ts"
export * from "./CrmStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9ef602')) {
      api.createRecord('4e9ef602', component.options)
    } else {
      api.reload('4e9ef602', component.options)
    }
    module.hot.accept("./CrmStatus.vue?vue&type=template&id=4e9ef602", function () {
      api.rerender('4e9ef602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmStatus.vue"
export default component.exports